import { StatusCode as GoloomStatusCode } from '@yandex-video-platform/goloom-sdk';

import { DeviceErrorCode } from '../device-manager/types';

export enum HiddenStatus {
    always = 'always',
    no = 'no',
    unknown = 'unknown',
}

export enum SubmodalId {
    PERMISSIONS_EXTENDED_RETURN_TO_DEFAULT = 'permissions-extended-return-to-default',
    PERMISSIONS_EXTENDED_RESET = 'permissions-extended-reset',
}

export const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const DEVICE_DENIED_ERRORS = new Set<DeviceErrorCode>([
    GoloomStatusCode.DEVICE_DENIED_BY_SYSTEM,
    GoloomStatusCode.DEVICE_DENIED_BY_USER,
]);
